module.exports = __webpack_public_path__ + "img/aidan.2c99a767.png";